import { useFormContext, useFormState } from "react-hook-form";

import { useAdminContentSettingsContext } from "@/search/AdminContentSettingsContext/AdminContentSettingsContext";

export const useSearchAdminPermissions = () => {
  const {
    enableContentSettingsFeatures,
    setApplyPermissionsModalActive,
    contentSettingsToggleEnabled,
  } = useAdminContentSettingsContext();

  const blockActionAndShowConfirmationModal = () => {
    if (enableContentSettingsFeatures) {
      setApplyPermissionsModalActive(true);
    }
  };

  const { control } = useFormContext();
  const { isDirty: isContentSettingsFormDirty } = useFormState({ control });

  return {
    blockActionAndShowConfirmationModal,
    blockFilterChanges:
      contentSettingsToggleEnabled && isContentSettingsFormDirty,
    isContentSettingsFormDirty,
  };
};
